import { API, APIError } from ".";
import type { OpenAPI } from "../../interfaces";

export const pages = (api: API) => ({
  getAll(
    forType: string,
    forId: string,
    success: (
      data: OpenAPI.GET<"/pages/{for_type}/{for_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/pages/${forType}/${forId}`,
      null,
      success,
      fail,
    );
  },
  getPinned(
    forType: string,
    forId: string,
    success: (
      data: OpenAPI.GET<"/pages/pinned/{for_type}/{for_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/pages/pinned/${forType}/${forId}`,
      null,
      success,
      fail,
    );
  },
  create(
    forType: string,
    forId: string,
    success: (
      data: OpenAPI.POST<"/pages/{for_type}/{for_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/pages/${forType}/${forId}`,
      null,
      success,
      fail,
    );
  },
  get(
    pageId: string,
    success: (data: OpenAPI.GET<"/pages/{page_id}">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/pages/${pageId}`,
      null,
      success,
      fail,
    );
  },
  edit(
    pageId: string,
    data: OpenAPI.PUT<"/pages/{page_id}">["requestBody"],
    success: (data: OpenAPI.PUT<"/pages/{page_id}">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("PUT", `/pages/${pageId}`, data, success, fail);
  },
  delete(
    pageId: string,
    success: (data: OpenAPI.DELETE<"/pages/{page_id}">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("DELETE", `/pages/${pageId}`, null, success, fail);
  },
});
